import { VendorReportsConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const VendorReportsActions = {
    searchVendorReports
};

function searchVendorReports(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: VendorReportsConstants.SEARCH_VENDORREPORTS_REQUEST,
            data: null
        }));
        adminUsersServices.VendorReports(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: VendorReportsConstants.SEARCH_VENDORREPORTS_SUCCESS,
                            data: response.data   
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: VendorReportsConstants.SEARCH_VENDORREPORTS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: VendorReportsConstants.SEARCH_VENDORREPORTS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data
    };
}